import { event, loader } from '../../Foundation';

export class NumberInput {
    /**
    * Creates an instance where user can manipulate with a textfield (number)
    * @param {HTMLElement} element input element
    */
    constructor(element, isAccessory = false, accessoryCartLineId, itemNo) {
        this.isAccessory = isAccessory;
        this.accessoryCartLineId = accessoryCartLineId;
        this.itemNo = itemNo;

        // Name, reference
        element.NumberInput = this;
        // Elements
        this._refs = {
            el: element,
            minus: element.querySelector('.number-input__button--minus'),
            input: element.querySelector('input[type="text"]'),
            plus: element.querySelector('.number-input__button--plus')
        };

        // Properties
        this._props = {
            min: this._refs.input.getAttribute('min') != null ? parseInt(this._refs.input.getAttribute('min')) : 0,
            max: this._refs.input.getAttribute('max') != null ? parseInt(this._refs.input.getAttribute('max')) : 99999,
            value: this._refs.input.value ? parseInt(this._refs.input.value) : 0,
            initial: this._refs.input.value ? parseInt(this._refs.input.value) : 0
        };

        // OnLoad
        this._updateInput();

        // State mangement: Disabled
        if (this._refs.input.disabled) {
            this._manageState();
            return false;
        } 

        // State management
        this._manageState();
        
        // Events listeners
        if(this._refs.minus) {
            this._refs.minus.addEventListener('click', this._onButtonClick.bind(this));
        }
        if(this._refs.plus) {
            this._refs.plus.addEventListener('click', this._onButtonClick.bind(this));
        }
        if(this._refs.input) {
            this._refs.input.addEventListener('keyup', this._onInputKeyUp.bind(this));
            this._refs.input.addEventListener('focusout', this._onFocusOut.bind(this));
        }

        if (this.isAccessory) {
            var removeAccessoryButtons = document.getElementsByClassName("remove-accessory");

            for (var i = 0; i < removeAccessoryButtons.length; i++) {
                removeAccessoryButtons[i].addEventListener("click", (e) => {
                    e.currentTarget.style.pointerEvents = "none";
                });
            }
        }
    }

    _reflow (e) {
        const oInput = e.target.querySelector('input');

        if (oInput != null) {
            // Value
            this._props.value = oInput.value;

            // Max
            this._props.max = oInput.getAttribute('max');

            // Min
            this._props.min = oInput.getAttribute('min');
        }
    }

    /**
     * _updateInput
     * @description Update input field with value and adjust width of element
     * @type private
     */
    _updateInput () {
        this._refs.input.value = this._props.value;
        this._refs.input.style.minWidth = this._refs.input.value.length * this.settings.width + 'px';
    }

    /**
     * manageState
     * @description Manage state for the entire component by checking properties after each interaction
     * @type private
     */
    _manageState () {
        if (this._refs.minus && this._refs.plus) {
            // Minimum limit
            if (this._props.value == this._props.min || this._refs.input.disabled) {
                this._refs.minus.classList.add(this.settings.disabledClass);
                this._setDisabled(this._refs.minus);

                if (this._refs.input.disabled) {
                    this._refs.minus.classList.add(this.settings.hiddenClass);
                }

            } else {
                this._refs.minus.classList.remove(this.settings.disabledClass);
                this._refs.minus.classList.remove(this.settings.hiddenClass);
                this._removeDisabled(this._refs.minus);
            }

            // Maximum limit 
            if (this._props.value == this._props.max || this._refs.input.disabled) {
                this._refs.plus.classList.add(this.settings.disabledClass);
                this._setDisabled(this._refs.plus)

                if (this._refs.input.disabled) {
                    this._refs.plus.classList.add(this.settings.hiddenClass);
                }
            } else {
                this._refs.plus.classList.remove(this.settings.disabledClass);
                this._refs.plus.classList.remove(this.settings.hiddenClass);
                this._removeDisabled(this._refs.plus)
            }

            event.emit(this._refs.input, 'change');
            // Emit state update
            event.emit(this._refs.el, 'numberinput.state-updated', this._props);
        }
    }

    /**
     * onButtonClick
     * @description Handler for when user interacts with buttons
     * @param {Event} e - Event interface
     * @type private
     */
    _onButtonClick(e) {
        const target = e.target;
        let type;

        this._props.value = this._refs.input.value ? parseInt(this._refs.input.value) : 0;

        if(target.classList.contains('is-disabled')) {
            return false;
        }

        if (target.classList.contains('number-input__button--minus')) {
            this._props.value--;
            type = 'minus';
        } else {
            this._props.value++;
            type = 'plus';
        }

        this._onInputValidation(e,
            () => {
                event.emit(this._refs.el, 'numberinput.' + type, this._props);
                this._set(e);
                event.emit(this._refs.input, 'change');
            });
    }

    /**
     * Set
     * @description Manage ruleset for input and chain call for updating state and layout
     * @param {Event} - Event Interface
     * @type private 
     */

    _set(e) {
        this._props.max = this._refs.input.getAttribute('max') ? parseInt(this._refs.input.getAttribute('max')) : 99999;
        
        if (this._props.value > this._props.max) {
            this._props.value = this._props.max;
        } else if (this._props.value < this._props.min) {
            this._props.value = this._props.min;
        }
        

        // Emit state update
        if (e.type === 'keyup' || e.type === 'click') {
            event.emit(this._refs.el, 'numberinput.before-update', this._props);
        }

        // Update state-based references 
        this._manageState();
        
        // Update layout
        this._updateInput();
        
        // Emit state update
        if (e.type === 'keyup' || e.type === 'click' || e.type === 'focusout') {
            if (this.isAccessory) {
                event.emit(this._refs.el, 'accessoriesnumberinput.updated', this._props);
            } else {
                event.emit(this._refs.el, 'numberinput.updated', this._props);
            }
        }

        // Update controller that is linked to input field
        if(this._refs.input.dataset.id) {
            const targetId = this._refs.input.dataset.id;
            document.getElementById(targetId).value = this._refs.input.value;
        }
    }

    /**
     * onInputKeyDown
     * @description When user presses down on a key inside input
     * @param {Event} e - Event interface
     * @type private
     */
    _onInputKeyDown(e) {
        const 
            keyCode = e.keyCode,
            isModifiers = e.ctrlKey || e.shiftKey || e.altKey || e.metaKey,
            isEnter = keyCode === 13,
            isNumeric = ["0","1","2","3","4","5","6","7","8","9"].indexOf(e.key) !== -1;

        this._props.value = this._refs.input.value ? parseInt(this._refs.input.value) : 0;

        if(keyCode === 38) { // Up 
            e.preventDefault();
            this._props.value++;
        } else if (keyCode === 40) { // Down
            e.preventDefault();
            this._props.value--;
        } else {
            let boolValidated = true;
            // Probit: Enter, Control, Shift, Alt, Meta, Non-numeric
            if(isEnter || isModifiers || !isNumeric) {
                boolValidated = false;
            } 

            // Allow: ArrowLeft, ArrowRight, Backspace, Delete
            if (keyCode === 37 || keyCode === 39 || keyCode === 46 || keyCode === 8) {
                boolValidated = true;
                
            }

            if (!boolValidated) {
                e.preventDefault();
                return false;
            }
            else {
                return false;
            }
        }
        
        // Enforce business ruleset
        this._onInputValidation(e, () => {
            this._set(e);
        });
	}

    _setDisabled(element) {
        element.setAttribute("aria-disabled", "true");
        element.setAttribute("tabindex", "-1");
    }

    _removeDisabled(element) {
        element.setAttribute("aria-disabled", "false");
        element.setAttribute("tabindex", "0");
    }

    /**
     * onInputKeyUp
     * @description When user slips a key within a input
     * @param {Event} e - Event interface
     * @type private
     */
    _onInputKeyUp(e) {
        // ArrowLeft, ArrowRight, Backspace, Delete
        if (e.keyCode === 37 || e.keyCode === 39 || e.keyCode === 46 || e.keyCode === 8) {
            e.preventDefault();
            return false;
        }

        this._props.value = this._refs.input.value ? parseInt(this._refs.input.value) : 0;
        if (e.keyCode === 38) { // Up 
            e.preventDefault();
            this._props.value++;
        } else if (e.keyCode === 40) { // Down
            e.preventDefault();
            this._props.value--;
        }

        this._set(e);
    }

    _onFocusOut(e) {
        const inputValue = parseInt(e.target.value || 0);
        if (inputValue !== this._props.value) {
            this._props.value = inputValue;
            this._set(e);
        }
    }

    _onInputValidation(e, callback) {
        const arrPages = Array.from(document.querySelectorAll('.cart, .favorites'));

        if (!arrPages.length) {
            callback();
            return false;
        }

        loader.show();
        const
            oCartline = e.target.closest('.cart-line'),
            oQuantityLimitExeceeded = oCartline.querySelector('[id="qtyUpdateError"]'),
            lineId = this.isAccessory ? this.accessoryCartLineId : oCartline.querySelector('#LineIdHiddenField').value,
            api = arrPages.filter(x => x.classList.contains('favorites')).length ? '/api/favorites/updatequantity' : this.isAccessory ? '/api/cart/accessorycartline/updatequantity' : '/api/cart/cartline/updatequantity';

        const bodyJSON = this.isAccessory ? 
            JSON.stringify({
                Id: lineId,
                Quantity: this._props.value,
                ItemNo: this.itemNo
            }) :
            JSON.stringify({
                Id: lineId,
                Quantity: this._props.value
            })

        fetch(api, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json'
            },
            body: bodyJSON
        }).then(response => {
            const status = response.status;

            switch (status) {
                case 400: // Min/Max amount execeeded
                    // Update input
                    this._props.value = this._props.initial;
                    this._props.max = this._props.initial;

                    // Update max attribute
                    this._refs.input.setAttribute('max', this._props.max);

                    oQuantityLimitExeceeded.classList.remove('is-hidden');
                    setTimeout(() => {
                        oQuantityLimitExeceeded.classList.add('is-hidden');
                    }, 5000);
                break;
            }

            callback();
        }).catch(response => {
            console.log("error", response);
            loader.hide();
        });
    }

    /**
     * Settings
     * @description Default settings for feature
     * @type public
     * @returns {Object}
     */
    get settings () {
        return {
            'disabledClass': 'is-disabled',
            'hiddenClass': 'is-hidden',
            'minusClass': '.number-input__button--minus',
            'plusClass': '.number-input__button--plus',
            'width': 11
        }
    }
}